import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
} from '@mui/material';
import * as React from 'react';
import {
    DateInput,
    DeleteButton,
    EditBase,
    Form,
    ReferenceInput,
    required,
    SaveButton,
    SelectInput,
    TextInput,
    Toolbar,
    useNotify,
} from 'react-admin';

import { DialogCloseButton } from '../misc/DialogCloseButton';

export const TaskEdit = ({
    open,
    close,
    taskId,
}: {
    taskId: string;
    open: boolean;
    close: () => void;
}) => {
    const notify = useNotify();
    return (
        <Dialog
            open={open}
            onClose={close}
            fullWidth
            disableRestoreFocus
            maxWidth="sm"
        >
            <EditBase
                id={taskId}
                resource="tasks"
                sx={{ '& .RaCreate-main': { mt: 0 } }}
                mutationOptions={{
                    onSuccess: () => {
                        close();
                        notify('Task updated', {
                            type: 'info',
                            undoable: true,
                        });
                    },
                }}
                redirect={false}
            >
                <Form>
                    <DialogCloseButton onClose={close} />
                    <DialogTitle id="form-dialog-title">Edit task</DialogTitle>
                    <DialogContent>
                        <TextInput
                            autoFocus
                            source="descricao_tarefa"
                            label="Description"
                            validate={required()}
                            multiline
                            helperText={false}
                        />
                        <Stack direction="row" spacing={1} mt={2}>
                            <DateInput
                                source="dthr_prevista"
                                validate={required()}
                                helperText={false}
                            />

                            <ReferenceInput
                                source="id_tipo"
                                reference="tasktypes"
                                filter={{ modulo: 'SCM' }}
                                sort={{ field: 'desc_tipo_tarefa', order: 'ASC' }}
                            >
                                <SelectInput
                                    label="Tipo de tarefa"
                                    optionText={choice => choice.desc_tipo_tarefa}
                                    helperText={false}
                                />
                            </ReferenceInput>
                        </Stack>
                    </DialogContent>
                    <DialogActions sx={{ p: 0 }}>
                        <Toolbar
                            sx={{
                                width: '100%',
                                justifyContent: 'space-between',
                                gap: 1,
                            }}
                        >
                            <SaveButton label="Save" />
                            <DeleteButton
                                label="Delete"
                                mutationOptions={{
                                    onSuccess: () => {
                                        close();
                                        notify('Task deleted', {
                                            type: 'info',
                                            undoable: true,
                                        });
                                    },
                                }}
                                redirect={false}
                            />
                        </Toolbar>
                    </DialogActions>
                </Form>
            </EditBase>
        </Dialog>
    );
};
